/**
 * Links into the DocuSign web app for an envelope.
 *
 * The host is per environment, set at build time: the sandbox (apps-d.docusign.com) for
 * dev/staging, production (apps.docusign.com) for prod. They are separate DocuSign
 * environments, so an envelope from one does not exist in the other.
 *
 * DocuSign asks for its own sign-in, so only people with access to the sending DocuSign
 * account can open the document. Unset means no link rather than a guess at the wrong
 * environment.
 */
const DOCUSIGN_WEB_URL = process.env.REACT_APP_DOCUSIGN_WEB_URL?.replace(
  /\/+$/,
  '',
);

export function docusignEnvelopeUrl(
  envelopeId: string | null | undefined,
): string | null {
  if (!envelopeId || !DOCUSIGN_WEB_URL) return null;
  return `${DOCUSIGN_WEB_URL}/send/documents/details/${encodeURIComponent(envelopeId)}`;
}
